import * as React from 'react';
import SEO from '../components/SEO/SEO';
import LayoutTemplate from './layout.template';
import { clearUrl } from '../utils/helperFunctions';
import { useLanguage } from '../locales';
import { graphql } from 'gatsby';
import { useLocation } from '@reach/router';
const FirstChildCategory = (props) => {
  const { translation, lang } = useLanguage();
  const { seo } = translation;
  const { pathname } = useLocation();
  return (
    <>
      <SEO
        title={
          seo.secondChildCategory[
            clearUrl(props.pageContext.second_child_category)
          ]
        }
        lang={lang}
        pathname={pathname}
      />
      <LayoutTemplate {...props} />
    </>
  );
};

export const query = graphql`
  query(
    $category: String!
    $first_child_category: String!
    $second_child_category: String!
    $limit: Int!
    $skip: Int!
  ) {
    blogs: allContentfulBlogPost(
      limit: $limit
      skip: $skip
      filter: {
        category: { eq: $category }
        first_child_category: { eq: $first_child_category }
        second_child_category: { eq: $second_child_category }
      }
      sort: { order: DESC, fields: updatedAt }
    ) {
      nodes {
        contentful_id
        title_en
        title_vi
        category
        first_child_category
        second_child_category
        tags
        author
        slug
        description_en
        description_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
    countBlogs: allContentfulBlogPost(
      filter: {
        category: { eq: $category }
        first_child_category: { eq: $first_child_category }
        second_child_category: { eq: $second_child_category }
      }
    ) {
      totalCount
    }
    tagsData: allContentfulBlogPost(
      filter: {
        category: { eq: $category }
        first_child_category: { eq: $first_child_category }
        second_child_category: { eq: $second_child_category }
      }
    ) {
      edges {
        node {
          tags
        }
      }
    }
    history: allContentfulBlogPost {
      nodes {
        createdAt
      }
    }
    recommendedPosts: allContentfulBlogPost(
      filter: {
        category: { eq: $category }
        first_child_category: { eq: $first_child_category }
        second_child_category: { eq: $second_child_category }
      }
      limit: 30
    ) {
      nodes {
        contentful_id
        title_en
        title_vi
        author
        description_en
        description_vi
        category
        first_child_category
        second_child_category
        slug
        tags
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
  }
`;

export default FirstChildCategory;
